import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import About from "./pages/about";
import India from "./pages/indian";
import Global from "./pages/global";
import Enterprise from "./pages/enterprises";
import Header from './component/common/header';
import Footer from './component/common/footer';
import NotFoundPage from "./component/common/notFoundPage";
import './App.css';
import WhatsAppChatWidget from "./component/common/WhatsAppWidget";
import LaunchHub from "./pages/launchhub";
import { Helmet } from "react-helmet-async";
import AnalyticsTracker from "./component/common/AnalyticsTracker";

const MainLayout = ({ children }) => (
  <>
    {children}
    <Footer />
  </>
);

const App = () => {
  return (
    <Router>
      <Helmet>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-XVR27ZR783"
        />
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-XVR27ZR783');
          `}
        </script>
      </Helmet>
      <AnalyticsTracker />
      <div className="min-h-screen bg-gray-100 overflow-x-hidden">
        <Header />

        {/* Page routes */}
        <Routes>
          <Route path="/" element={<MainLayout><Home /></MainLayout>} />
          <Route path="/about" element={<MainLayout><About /></MainLayout>} />
          <Route path="/indian" element={<MainLayout><India /></MainLayout>} />
          <Route path="/global" element={<MainLayout><Global /></MainLayout>} />
          <Route path="/enterprise" element={<MainLayout><Enterprise /></MainLayout>} />
          <Route path="/enterprise" element={<MainLayout><Enterprise /></MainLayout>} />
          <Route path="/launchhub" element={<MainLayout><LaunchHub /></MainLayout>} />
          {/* <Route path="/ccl" element={<MainLayout><Contact /></MainLayout>} /> */}

          {/* 404 route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <WhatsAppChatWidget />
      </div>
    </Router>
  );
};

export default App;
